import React from 'react';
import { arrayOf, string, bool, func } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { Carousel } from '@one-thd/sui-carousel';
import { publish } from '../utils/publisher';

const SupplementalTilesCarousel = ({
  productsData, schemaName, isDrawerShow, onClickShowDrawer
}) => {

  const handleImageClick = (idx) => {

    publish({
      componentName: 'supplemental-recs',
      eventName: 'click',
      data: {
        position: idx + 1,
        schemaName
      }
    });
  };

  return (
    <>
      {productsData?.length
        && (
          <Carousel
            breakpoints={{
              sm: {
                slidesPerView: 3,
                slidesPerGroup: 3
              },
              md: {
                slidesPerView: 4,
                slidesPerGroup: 4
              },
              lg: {
                slidesPerView: 5,
                slidesPerGroup: 5
              },
              xl: {
                slidesPerView: 6,
                slidesPerGroup: 6
              }
            }}
          >
            {
              productsData.map((prod, idx) => {
                const imageUrl = prod?.product?.media?.images?.[0]?.url;
                const { productLabel } = prod?.product?.identifiers;
                const itemId = prod?.product.itemId;

                return (
                  <div key={itemId}>
                    <meta data-prop="name" content={itemId} />
                    { isDrawerShow
                      ? (
                        <Image
                          src={imageUrl.replace('<SIZE>', '300')}
                          lazy
                          stretchy
                          alt={productLabel}
                          title={productLabel}
                          onClick={onClickShowDrawer}
                        />
                      )
                      : (
                        <a
                          href={prod?.product?.identifiers?.canonicalUrl}
                          onClick={() => handleImageClick(idx)}
                        >
                          <Image
                            src={imageUrl.replace('<SIZE>', '300')}
                            lazy
                            stretchy
                            alt={productLabel}
                            title={productLabel}
                          />
                        </a>
                      )}
                  </div>
                );
              })
            }
          </Carousel>
        )}
    </>
  );
};

SupplementalTilesCarousel.propTypes = {
  productsData: arrayOf(Object),
  schemaName: string,
  isDrawerShow: bool,
  onClickShowDrawer: func
};

SupplementalTilesCarousel.defaultProps = {
  productsData: null,
  schemaName: '',
  isDrawerShow: null,
  onClickShowDrawer: () => {}
};

export { SupplementalTilesCarousel };